import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import * as moment from 'moment';

@Component({
  selector: 'app-date-cell-renderer',
  template: `{{ formattedDate }}`
})
export class DateTimeCellRendererComponent implements ICellRendererAngularComp {
  public formattedDate: string | undefined;

  agInit(params: any): void {
    this.formattedDate = this.getFormatedDate(params.value);
  }

  refresh(params: any): boolean {
    this.formattedDate = this.getFormatedDate(params.value);
    return true;
  }

  getFormatedDate(date: any): string | undefined {
    return date ? moment(date).format('DD-MMM-YYYY') : undefined
  }
}